/** @format */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, retry } from 'rxjs/operators';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SmsMarketingOptInStatus } from './sms-marketing-opt-in-status.interface';
import { environment } from '@environment/cart';

const SMS_MARKETING_HTTP_HEADERS = new HttpHeaders({
	Accept: 'application/json;',
	'Content-Type': 'application/json',
	'Access-Control-Allow-Origin': '*',
	'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
	Pragma: 'no-cache',
	Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
	'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`,
	partner_key: environment.apiTokens.exComm.marketing.partnerKey,
	secret_key: environment.apiTokens.exComm.marketing.secretKey
});

@Injectable({
	providedIn: 'root'
})
export class SmsMarketingDao {
	constructor(private http: HttpClient) {}

	public setSmsMarketingOptInValue(smsOptInData: {
		brand: string;
		optIn: boolean;
		phoneNumber: string;
		sourceType: string;
		type: string;
	}): Observable<SmsMarketingOptInStatus> {
		const httpOptions = {
			headers: SMS_MARKETING_HTTP_HEADERS,
			withCredentials: true
		};

		const url = `${environment.api.exComm.marketing}/update`;

		return this.http.post<SmsMarketingOptInStatus>(url, smsOptInData, httpOptions).pipe(
			map((data: any) => {
				return data;
			}),
			retry(1)
		);
	}

	public getSmsMarketingOptInStatus(smsMarketingOptInIdentifiers: {
		brand: string;
		phoneNumber: string;
		type: string;
	}): Observable<SmsMarketingOptInStatus> {
		const httpOptions = {
			headers: SMS_MARKETING_HTTP_HEADERS,
			withCredentials: true
		};

		const url = `${environment.api.exComm.marketing}/status`;

		return this.http
			.post<SmsMarketingOptInStatus>(url, smsMarketingOptInIdentifiers, httpOptions)
			.pipe(
				map((data: any) => {
					return data;
				}),
				retry(1)
			);
	}
}
